import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import * as actions from '../../store/actions';
import { GoogleLogin } from 'react-google-login';
import { isLoggedIn } from '../../helperFunctions';
import { Redirect } from 'react-router-dom';

var style = { minHeight: '500px' };

class HomePageContainer extends Component {
  handleGoogleResponse = response => {
    const payload = {
      provider: 'google',
      code: response.code,
      callback: this.props.callback,
    };
    this.props.loginUsingGoogle(payload);
  };

  render() {
    const { t, user_detail } = this.props;

    return (
      <div
        className="home_page_container"
        style={style}
      >
        {isLoggedIn(user_detail.user_id) ? (
          <Redirect to="/invite" />
        ) : (
          <GoogleLogin
            clientId="73660977592-m50kcgualicen86vokvsbg3vsh8h6c2e.apps.googleusercontent.com"
            buttonText={t('google_login.sign_in')}
            responseType="code"
            onSuccess={response => this.handleGoogleResponse(response)}
            onFailure={response => this.handleGoogleResponse(response)}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loginUsingGoogle: payload => dispatch(actions.loginUsingGoogle(payload)),
});

const mapStateToProps = state => ({
  user_detail: state.auth,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('auth')(HomePageContainer));
